export default __webpack_public_path__ + "static/tab-img01-51c4eb6f9829111bb47ff1161d37ffd0.png";